<!-- <div class="btn-group me-2">
    <button (click)="createCandidateActivities()">CreateActivities</button>
</div> -->

<div class="btn-group me-2">
  <button routerLink="log"> view log </button>
  <button routerLink="users"> Manage users </button>
  <!-- <button routerLink="admin-configuration"> Admin configuration </button> -->
  <button (click)="updateEmail()" *ngIf="hasSysAccess"> Copy email </button>
</div>
<hr>
<router-outlet></router-outlet>
